import {Command} from '@application/command/command';
import {createProductionScheduleItemInPathGroupFromDrawing, renameProductionSchedulePathsToNewPositionInColoredYarnSets} from '@application/helper/production-schedule-builder';
import {updateProductionSchedulePathsOfColoredYarnSets} from '@application/helper/production-schedule-builder/update-production-schedule-paths-of-colored-yarn-sets';
import {ProductionSchedule} from '@domain/production-schedule/production-schedule';
import {ProductionSchedulePath} from '@domain/production-schedule/production-schedule-path';
import {ProductionSchedulePathsOfColoredYarnSet} from '@domain/production-schedule/production-schedule-paths-of-colored-yarn-set';
import {OverviewListColoredYarnSetWithStartDent} from '@domain/textile-data/creel/overview-list-colored-yarn-set-with-start-dent';
import {ListDrawingOrderLine} from '@presentation/components/drawing-list/list-drawing-order-line';
import {ParametersForAddingDrawingToColoredYarnSet} from '@presentation/pages/texfab/production-schedule/add/plan/parameters-for-adding-drawing-to-colored-yarn-set';
import {ArrayUtils, AssertionUtils} from '@vdw/angular-component-library';

export class AddDrawingToColoredYarnSetCommand implements Command<ParametersForAddingDrawingToColoredYarnSet, ProductionSchedule> {
  public execute(commandArgs: ParametersForAddingDrawingToColoredYarnSet): ProductionSchedule {
    const {productionSchedule, listDrawing, startDentOfColoredYarnSet, indexInColoredYarnSet, uuidForProductionScheduleInPathGroup} = commandArgs;

    const productionScheduleColoredYarnSet = productionSchedule.getProductionScheduleColoredYarnSetAtStartDent(startDentOfColoredYarnSet);
    const productionSchedulePathsOfColoredYarnSet = productionSchedule.getProductionSchedulePathsOfColoredYarnSetAtStartDent(startDentOfColoredYarnSet);

    const productionScheduleItemInPathGroup = createProductionScheduleItemInPathGroupFromDrawing(
      listDrawing instanceof ListDrawingOrderLine ? null : productionSchedule.finishing,
      listDrawing,
      productionSchedule.machineQuality
    );
    if (!AssertionUtils.isNullOrUndefined(uuidForProductionScheduleInPathGroup)) {
      productionScheduleItemInPathGroup.adjustUuid(uuidForProductionScheduleInPathGroup);
    }

    const commercialWidthInMM = productionScheduleItemInPathGroup?.commercialDimensionsInMM?.widthInMM;

    const newProductionSchedulePath: ProductionSchedulePath = new ProductionSchedulePath(
      null,
      null,
      commercialWidthInMM,
      productionScheduleItemInPathGroup.technicalDimensions.widthInDents,
      [productionScheduleItemInPathGroup],
      null,
      null,
      null
    );

    if (AssertionUtils.isNullOrUndefined(indexInColoredYarnSet)) {
      this.addPathToEndOfColoredYarnSet(productionSchedulePathsOfColoredYarnSet, newProductionSchedulePath, productionScheduleColoredYarnSet);
    } else {
      this.addPathGivenPositionInColoredYarnSet(productionSchedulePathsOfColoredYarnSet, indexInColoredYarnSet, newProductionSchedulePath);
    }

    renameProductionSchedulePathsToNewPositionInColoredYarnSets(productionSchedule);

    return updateProductionSchedulePathsOfColoredYarnSets(productionSchedule);
  }

  private addPathGivenPositionInColoredYarnSet(
    productionSchedulePathsOfColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet,
    indexInColoredYarnSet: number,
    newProductionSchedulePath: ProductionSchedulePath
  ): void {
    const totalWidthInDentsOfProductionSchedulePaths = ArrayUtils.sum(
      Array.from(
        productionSchedulePathsOfColoredYarnSet.productionSchedulePaths.slice(0, indexInColoredYarnSet),
        (productionSchedulePath: ProductionSchedulePath) => productionSchedulePath.technicalWidthInDents
      )
    );

    newProductionSchedulePath.startDent = totalWidthInDentsOfProductionSchedulePaths + 1;

    productionSchedulePathsOfColoredYarnSet.productionSchedulePaths.splice(indexInColoredYarnSet, 0, newProductionSchedulePath);
  }

  private addPathToEndOfColoredYarnSet(
    productionSchedulePathsOfColoredYarnSet: ProductionSchedulePathsOfColoredYarnSet,
    newProductionSchedulePath: ProductionSchedulePath,
    productionScheduleColoredYarnSet: OverviewListColoredYarnSetWithStartDent
  ): void {
    const totalWidthInDentsOfProductionSchedulePaths = ArrayUtils.sum(
      Array.from(productionSchedulePathsOfColoredYarnSet.productionSchedulePaths, (productionSchedulePath: ProductionSchedulePath) => productionSchedulePath.technicalWidthInDents)
    );

    newProductionSchedulePath.startDent =
      totalWidthInDentsOfProductionSchedulePaths === 0 ? productionScheduleColoredYarnSet.startDent : totalWidthInDentsOfProductionSchedulePaths + productionScheduleColoredYarnSet.startDent + 1;

    productionSchedulePathsOfColoredYarnSet.productionSchedulePaths.push(newProductionSchedulePath);
  }
}
